<script setup>
import StormCenter from '@/components/StormCenter.vue';
import ToastHost from '@/components/base/ToastHost.vue';

</script>

<template>
  <Suspense>
    <StormCenter />
  </Suspense>
  <ToastHost />
</template>
